import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from '../i18n';

const Group = styled.div`
  display: inline-flex;
  gap: 4px;
  padding: 4px;
  border-radius: ${({ theme }) => theme.radii.pill};
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(8px);
  box-shadow: ${({ theme }) => theme.shadows.puff};
`;

const Choice = styled.button<{ $active: boolean }>`
  padding: 6px 13px;
  border-radius: ${({ theme }) => theme.radii.pill};
  font-size: 0.85rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.inkSoft};
  transition: all 200ms ${({ theme }) => theme.transitions.bounce};

  ${({ $active, theme }) =>
    $active &&
    css`
      background: ${theme.colors.bubblegum};
      color: #fff;
      box-shadow: 0 3px 0 ${theme.colors.bubblegumDeep};
    `}

  &:hover:not(:disabled) {
    transform: translateY(-1px);
  }
`;

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const current = i18n.resolvedLanguage ?? i18n.language;

  return (
    <Group role="group" aria-label={t('common.language')}>
      {SUPPORTED_LANGUAGES.map((language) => (
        <Choice
          key={language.code}
          type="button"
          $active={current === language.code}
          aria-pressed={current === language.code}
          onClick={() => void i18n.changeLanguage(language.code)}
        >
          {language.flag} {language.label}
        </Choice>
      ))}
    </Group>
  );
}
